﻿const cookieTime = (minutes) => {
  var now = new Date();
	var time = now.getTime();

	time += minutes * 60 * 1000;
	now.setTime(time);
	return now;
}

export const setCookie = (name, value, minutes = 60) => {
  document.cookie = `${name}=${value}; expires=${cookieTime(minutes)}; path=/`;
}

export const getCookie = (name) => {
  var cookieName = name + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(cookieName) == 0) {
      return c.substring(cookieName.length, c.length);
    }
  }
  return "";
}

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
}